"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnDGridItemHandle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_aria_1 = require("react-aria");
const src_1 = require("../..");
/** Provides a specific handle element for dragging a GridItem. Includes handling behaviors and interactions */
function DnDGridItemHandle(props) {
    const { dragHandleProps, icon = "move", compact = false, color } = props;
    const { focusProps, isFocusVisible } = (0, react_aria_1.useFocusRing)();
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({});
    const tid = (0, src_1.useTestIds)(props, "dragHandle");
    const iconButtonNormal = src_1.Css.hPx(28).wPx(28).br8.bw2.$;
    const iconButtonCompact = src_1.Css.hPx(18).wPx(18).br4.bw1.$;
    return ((0, jsx_runtime_1.jsx)("button", { css: {
            ...(compact ? iconButtonCompact : iconButtonNormal),
            ...src_1.Css.cursor("grab").bcTransparent.bss.bgTransparent.outline0.dif.aic.jcc.transition.if(isFocusVisible)
                .bcBlue700.$,
            ...(isHovered && src_1.Css.bgGray200.$),
        }, ...(0, react_aria_1.mergeProps)(dragHandleProps, focusProps, hoverProps), ...tid, children: (0, jsx_runtime_1.jsx)(src_1.Icon, { icon: icon, inc: compact ? 2 : undefined, color: color }) }));
}
exports.DnDGridItemHandle = DnDGridItemHandle;
